import { render, staticRenderFns } from "./DebugMenu.vue?vue&type=template&id=a30ae420"
import script from "./DebugMenu.ts?vue&type=script&lang=ts&external"
export * from "./DebugMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./DebugMenu.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports